import React from "react";
import { useDispatch, useSelector } from "react-redux";
import like from "../../assets/like.svg";
import unLike from "../../assets/unlike.svg";
import { updateLikeUnlike } from "../../features/updateLikeUnlike/updateLikeUnlikeSlice";

const LikeUnLike = ({ videoInfo }) => {
    const { updatedVideo, isError, error } = useSelector(
        (state) => state.updateLikeUnlike
    );
    const dispatch = useDispatch();
    const { id, likes, unlikes } = videoInfo;

    const handleLikeUpdate = () => {
        isError && alert(error);

        /*First time taking the dynamic videos likes and unlikes, 
        after that when user clicking on like or unlike, pushing that updated 
        like and unlike videoInfo into a new slice state and showing that info on 
        the UI, so that the whole page doesn't **Rerender** everyTime*/
        const updatedLikes = updatedVideo?.id
            ? updatedVideo.likes + 1
            : likes + 1;
        const updatedUnlikes = updatedVideo?.id
            ? updatedVideo.unlikes
            : unlikes;

        dispatch(
            updateLikeUnlike({
                videoId: id,
                likes: updatedLikes,
                unlikes: updatedUnlikes,
            })
        );
    };

    const handleUnLikeUpdate = () => {
        isError && alert(error);

        /*First time taking the dynamic videos likes and unlikes, 
        after that when user clicking on like or unlike, pushing that updated 
        like and unlike videoInfo into a new slice state and showing that info on 
        the UI, so that the whole page doesn't **Rerender** everyTime*/
        const updatedUnLikes = updatedVideo?.id
            ? updatedVideo.unlikes + 1
            : unlikes + 1;
        const updatedLikes = updatedVideo?.id ? updatedVideo.likes : likes;

        dispatch(
            updateLikeUnlike({
                videoId: id,
                likes: updatedLikes,
                unlikes: updatedUnLikes,
            })
        );
    };

    return (
        <div className="flex gap-10 w-48">
            <div className="flex gap-1 ">
                <div className="shrink-0">
                    <img
                        onClick={handleLikeUpdate}
                        className="w-5 block  cursor-pointer"
                        src={like}
                        alt="Like"
                    />
                </div>
                <div className="text-sm leading-[1.7142857] text-slate-600">
                    {updatedVideo?.id ? updatedVideo.likes : likes}
                </div>
            </div>
            <div className="flex gap-1">
                <div className="shrink-0">
                    <img
                        onClick={handleUnLikeUpdate}
                        className="w-5 block  cursor-pointer"
                        src={unLike}
                        alt="Unlike"
                    />
                </div>
                <div className="text-sm leading-[1.7142857] text-slate-600">
                    {updatedVideo?.id ? updatedVideo.unlikes : unlikes}
                </div>
            </div>
        </div>
    );
};

export default LikeUnLike;
